module.exports = __webpack_public_path__ + "img/icon_round_check.6b21057e.svg";